<template>
  <el-container class="Wrapper">
    <el-container class="container">
      <el-main class="main">
        <div class="main_item">
          <div class="dang">
            <div class="QRcode">
              <!-- 查询条件区域 -->
              <div class="zhuang">
                <span class="Separateds">订单号</span>
                <el-input style="width: 10vw" v-model="input" placeholder="请输入订单号" @keyup.enter="query"
                  @change="sift"></el-input>
                <span class="Separateds">楼层选择</span>
                <!-- 添加楼栋筛选框 -->
                <el-select style="width: 10vw" v-model="selectedBuilding" filterable placeholder="请选择楼栋" @change="sift">
                  <el-option label="全部楼区" value=""></el-option>
                  <el-option v-for="building in buildingOptions" :key="building" :label="building" :value="building" />
                </el-select>

                <span class="Separateds">日期范围：</span>
                <span style="width: 22vw">
                  <el-date-picker class="select" v-model="value2" type="daterange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
                </span>
                <span class="Separateds">订单状态</span>
                <span>
                  <el-select style="width: 10vw" v-model="value" filterable placeholder="请选择订单状态"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </span>

              </div>
              <div class="zhuang1">
                <span>
                  <el-button type="primary" @click="showExportDialog = true">导出</el-button>
                </span>
                <span>
                  <el-button type="primary" @click="sift">查找</el-button>
                </span>
                <span>
                  <el-button type="primary" @click="batchVerify" :disabled="!canBatchVerify">批量配送</el-button>
                </span>
                <span>
                  <el-button type="danger" @click="batchRefund" :disabled="!canBatchRefund">批量退款</el-button>
                </span>
                <!-- <span>
                                    <el-button type="primary" @click="Ingredients">导出今日食材</el-button>
                                </span> -->
                <span>
                  <el-button type="primary" @click="printSelectedAsPDF">打印选中订单</el-button>
                </span>
                <el-button type="primary" @click="printSelectedReceipts" :disabled="!hasSelectedOrders">
                  打印选中订单小票
                </el-button>
              </div>
              <!-- 订单列表区域 -->
              <div class="list">
                <el-table v-loading="loading" element-loading-text="加载中，请稍后..." :data="orderser" height="65vh" border
                  @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="50px"></el-table-column>
                  <el-table-column prop="id" label="订单号" width="200px" label-class-name="ding" />
                  <el-table-column prop="" label="订单状态" width="200px">
                    <template #default="{ row }">
                      <span v-if="row.orderStatus === 0">
                        <el-tag type="primary">未支付</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 1">
                        <el-tag type="success">已支付</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 2">
                        <el-tag type="danger">待配送</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 3">
                        <el-tag type="primary">待收货</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 5">
                        <el-tag type="info">已退款</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 6">
                        <el-tag type="warning">申请退款</el-tag>
                      </span>
                      <span v-if="row.orderStatus === 4">
                        <el-tag type="success">已完成</el-tag>
                      </span>
                      <span v-else-if="row.orderStatus === 7">
                        <el-tag type="primary">库存不足</el-tag>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="收货人地址" width="200px" />
                  <el-table-column prop="storeName" label="商品门店" width="200px" />
                  <el-table-column prop="consignee" label="收货人名称" width="200px" />
                  <el-table-column prop="mobile" label="收货人电话" width="200px" />
                  <el-table-column prop="message" label="用户留言" width="200px" />
                  <el-table-column prop="goodsName" label="商品名称" width="200px" />
                  <el-table-column fixed="right" prop="address" label="操作" width="200px" #default="{ row }" class="cao">
                    <el-button type="primary" v-if="row.orderStatus === 2 || row.orderStatus === 1" @click="
                      shipments(
                        row.id,
                        row.goodsName,
                        row.mobile,
                        row.openId,
                        row.orderStatus,
                        row.wxUserId,
                        row.addOrderTime,
                        row.storeId,
                        row.message,
                        row.orderPrice,
                        row.goodsId,
                        row.goodsNumber,
                        row.goodsUrl,
                        row.shippingMethod,
                        row.storeName,
                        row.storeTxImg
                      )
                      ">
                      配送
                    </el-button>
                    <!-- <el-button type="primary"
                                            v-else-if="row.orderStatus !== 5 && row.orderStatus !== 0 && row.orderStatus !== 4 && row.orderStatus !== 6 && row.orderStatus !== 7"
                                            @click="opes(row.id, row.orderStatus, row.goodsId, row.inviteId)">
                                            合销
                                        </el-button> -->
                    <el-button type="primary" v-if="row.orderStatus === 6 || row.orderStatus === 7" @click="
                      refunds(
                        row.id,
                        row.goodsName,
                        row.mobile,
                        row.openId,
                        row.orderStatus,
                        row.wxUserId,
                        row.addOrderTime,
                        row.storeId,
                        row.message,
                        row.orderPrice,
                        row.goodsId,
                        row.goodsNumber,
                        row.goodsUrl,
                        row.shippingMethod,
                        row.storeName,
                        row.storeTxImg,
                        row.ordersSystemType
                      )
                      ">
                      全额退款
                    </el-button>
                    <el-button type="primary" class="part" v-if="row.orderStatus === 6 || row.orderStatus === 7" @click="
                      refund(
                        row.id,
                        row.goodsName,
                        row.mobile,
                        row.orderStatus,
                        row.wxUserId,
                        row.addOrderTime,
                        row.storeId,
                        row.message,
                        row.orderPrice,
                        row.goodsId,
                        row.goodsNumber,
                        row.goodsUrl,
                        row.shippingMethod,
                        row.storeName,
                        row.storeTxImg,
                        row.ordersSystemType
                      )
                      ">
                      部分退款
                    </el-button>
                    <el-button type="primary" id="details" @click="detail(row.id, row.goodsId)">
                      详情
                    </el-button>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 分页区域 -->
              <div class="demo-pagination-block">
                <el-pagination v-model:current-page="currentPage4" v-model:page-size="pageSize4"
                  :page-sizes="[10, 20, 50, 100]" :small="small" :disabled="disabled" :background="background"
                  layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" />
              </div>

              <!-- 详情弹窗区域 -->
              <div class="popups-overlay" v-if="showModals">
                <div class="popups-container">
                  <div class="popups-header">
                    <span class="popups-title">商品详情</span>
                    <span class="popups-close" @click="toggleModals">&times;</span>
                  </div>
                  <div class="popups-body">
                    <el-form :model="form" label-position="left" label-width="120px">
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="订单号：">
                            {{ detailes.id }}
                          </el-form-item>
                          <el-form-item label="收货人姓名：">
                            {{ detailes.consignee }}
                          </el-form-item>
                          <el-form-item label="订单状态：">
                            <span v-if="detailes.orderStatus === 0">
                              <el-tag type="info">未支付</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 1">
                              <el-tag type="success">已支付</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 2">
                              <el-tag type="warning">待配送</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 3">
                              <el-tag type="primary">待收货</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 4">
                              <el-tag type="success">已完成</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 5">
                              <el-tag type="info">已退款</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 6">
                              <el-tag type="danger">申请退款</el-tag>
                            </span>
                            <span v-else-if="detailes.orderStatus === 7">
                              <el-tag type="warning">库存不足</el-tag>
                            </span>
                          </el-form-item>
                          <el-form-item label="收货人电话：">
                            <span>{{ detailes.mobile }}</span>
                          </el-form-item>
                          <el-form-item label="收货人地址：">
                            {{ detailes.address }}
                          </el-form-item>
                          <el-form-item label="物流单号：">
                            <span>{{ detailes.trackingNumber }}</span>
                          </el-form-item>
                          <el-form-item label="用户留言：">
                            <span>{{ detailes.message || "无" }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="商品名称：">
                            <span>{{ detailes.goodsName }}</span>
                          </el-form-item>
                          <el-form-item label="商品图片：">
                            <el-image style="width: 120px; height: 120px"
                              :src="`https://199shq.com/api/common/download?name=${detailes.goodsUrl}`"
                              :preview-src-list="[
                                `https://199shq.com/api/common/download?name=${detailes.goodsUrl}`,
                              ]" fit="cover" lazy>
                            </el-image>
                          </el-form-item>
                          <el-form-item label="商品数量：">
                            <span>{{ detailes.goodsNumber }}</span>
                          </el-form-item>
                          <el-form-item label="订单总价格：">
                            <span class="price">￥{{ detailes.orderPrice }}</span>
                          </el-form-item>
                          <el-form-item label="物流方式：">
                            <span>{{ detailes.shippingMethod }}</span>
                          </el-form-item>
                          <el-form-item label="送达时间：">
                            <span>{{ detailes.deliveryTime }}</span>
                          </el-form-item>
                          <el-form-item label="订单创建时间：">
                            <span>{{ detailes.addOrderTime }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-divider></el-divider>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="门店名称：">
                            <span>{{ detailes.storeName }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="门店头像：">
                            <el-image style="width: 100px; height: 100px"
                              :src="`https://199shq.com/api/common/download?name=${detailes.storeTxImg}`"
                              :preview-src-list="[
                                `https://199shq.com/api/common/download?name=${detailes.storeTxImg}`,
                              ]" fit="cover" lazy>
                            </el-image>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                  <div class="popups-footer">
                    <el-button @click="toggleModals">关闭</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-dialog title="导出数据" v-model="showExportDialog" width="400px" :before-close="handleClose">
            <el-form :model="exportForm" label-width="80px">
              <!-- 单个日期选择（替换时间范围） -->
              <el-form-item label="选择日期">
                <el-date-picker v-model="exportForm.date" type="date" placeholder="请选择日期"
                  value-format="YYYY-MM-DD"></el-date-picker>
              </el-form-item>

              <!-- 导出类型选择 -->
              <el-form-item label="导出类型">
                <el-radio-group v-model="exportForm.dataType">
                  <el-radio label="kitchen">厨房数据</el-radio>
                  <el-radio label="statement">对餐单</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>

            <template #footer>
              <el-button @click="showExportDialog = false">取消</el-button>
              <el-button type="primary" @click="confirmExport">确认导出</el-button>
            </template>
          </el-dialog>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, reactive, onMounted, watch, onUnmounted } from "vue";
import { toRaw } from "vue";
import { useRouter } from "vue-router";
import instance from "../network/storester.js";
import { ElMessage, ElMessageBox } from "element-plus";
import { clone } from "xe-utils";
import html2pdf from "html2pdf.js";
import logoImg from "../image/logoss.png";
// 添加定时器引用
let paidOrderCheckInterval = null;
import logoImgs from "../image/logos.jpg";

// 订单列表数据
const orderser = ref([]);
const orderse = ref(null);
// 加载状态
const loading = ref(true);
const router = useRouter();
// 详情弹窗显示状态
const showModals = ref(false);
const data = reactive([]);
// 总记录数
const total = ref(0);
// 详情数据
const detailes = ref([]);
const detaile = ref(null);
// 日期范围选择值
const value2 = ref([]);
// 分页信息
const page = reactive({ pageNum: 1, pageSize: 10 });
// 选中的订单列表
const multipleSelection = ref([]);
// 楼栋选项列表
const buildingOptions = ref([]);
// 选中的楼栋
const selectedBuilding = ref("");

// 获取所有楼栋信息（只显示综合楼和急诊楼）
const fetchBuildingOptions = () => {
  // 直接写死楼栋信息，只显示综合楼和急诊楼
  buildingOptions.value = ["综合楼", "急诊楼", "其他"];
  console.log("楼栋信息已设置为写死数据:", buildingOptions.value);
};
const canBatchRefund = ref(false);
// 表格选择项改变时触发
const handleSelectionChange = (val) => {
  multipleSelection.value = val;
  // 检查勾选的订单是否全是待发货状态（原批量配送判断）
  canBatchVerify.value = multipleSelection.value.every((item) => item.orderStatus === 2);

  // 新增：检查勾选的订单是否全是申请退款状态（用于批量退款判断）
  canBatchRefund.value = multipleSelection.value.length > 0 &&
    multipleSelection.value.every((item) => item.orderStatus === 6);

  // 原有逻辑：控制打印按钮状态
  hasSelectedOrders.value = multipleSelection.value.length > 0;
};
// 批量退款操作
// 批量退款操作（循环处理版本）
const batchRefund = () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning('请先选择要退款的订单');
    return;
  }

  ElMessageBox.confirm(`您确定要对选中的 ${multipleSelection.value.length} 个订单进行批量退款吗？`, '退款确认', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    loading.value = true;
    let successCount = 0;
    const totalCount = multipleSelection.value.length;
    const errorOrders = [];

    // 循环处理每个订单的退款
    for (const order of multipleSelection.value) {
      try {
        // 确保订单是申请退款状态
        if (order.orderStatus !== 6) {
          errorOrders.push({ id: order.id, reason: '不是申请退款状态' });
          continue;
        }

        // 执行退款操作
        const values = parseInt(order.orderPrice * 100);
        const refundable = {
          outTradeNo: order.id,
          refund: values,
        };

        // 等待当前订单退款完成再处理下一个
        const response = await instance.post(`/api/pay/payRefund`, refundable);

        if (response.status === 200) {
          successCount++;
        } else {
          errorOrders.push({ id: order.id, reason: '退款接口返回异常' });
        }
      } catch (error) {
        console.error(`订单 ${order.id} 退款失败:`, error);
        errorOrders.push({
          id: order.id,
          reason: error.message || '处理过程发生错误'
        });
      }
    }

    // 处理完成后显示结果
    loading.value = false;
    let message = `批量退款处理完成，成功 ${successCount}/${totalCount} 个订单`;

    if (errorOrders.length > 0) {
      message += `，失败 ${errorOrders.length} 个订单：\n`;
      errorOrders.forEach(item => {
        message += `订单 ${item.id}：${item.reason}\n`;
      });
    }

    // 显示结果消息
    if (errorOrders.length > 0) {
      ElMessageBox.alert(message, '退款结果', {
        type: 'warning',
        confirmButtonText: '确定'
      });
    } else {
      ElMessage({
        type: 'success',
        message: message
      });
    }

    // 刷新订单列表
    sift();
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消批量退款',
    });
  });
};

// 每页条数改变时触发
const handleSizeChange = (val) => {
  page.pageSize = val;
  //console.log(val);
  sift();
};

// 添加检查新支付订单的函数
// const checkNewlyPaidOrders = () => {
//   // 只查询已支付的订单
//   let datas = {
//     orderStatus: 1, // 已支付状态
//     pageNum: 1,
//     pageSize: 30, // 获取最近30个已支付订单
//     wxUserId: "",
//     id: "",
//     addOrderTimeBegin: "",
//     addOrderTimeEnd: "",
//   };

//   if (localStorage.getItem("permissionsStatus") !== "0") {
//     datas.storeId = localStorage.getItem("sysStoreId");
//   }

//   instance
//     .post("/api/orders/list", datas)
//     .then((res) => {
//       const paidOrders = res.data.data.dataList || [];

//       // 获取已处理过的订单ID
//       const processedPaidOrders = JSON.parse(
//         localStorage.getItem("newlyPaidOrders") || "[]"
//       );

//       // 筛选出新出现的已支付订单
//       const newlyPaidOrders = paidOrders.filter(
//         (order) => !processedPaidOrders.includes(order.id)
//       );

//       // 对新出现的已支付订单自动打印小票
//       if (newlyPaidOrders.length > 0) {
//         console.log(`检测到 ${newlyPaidOrders.length} 个新已支付订单，开始自动打印...`);

//         newlyPaidOrders.forEach((order, index) => {
//           // 延时打印，避免同时打印多个订单造成冲突
//           setTimeout(() => {
//             try {
//               silentPrintReceipt(order, 2);
//               console.log("已打印订单:", order.id);

//               // 显示提示信息
//               ElMessage({
//                 message: `检测到新订单 ${order.id} 已支付，正在自动打印小票`,
//                 type: "success",
//                 duration: 3000,
//               });
//             } catch (printError) {
//               console.error("打印小票时出错:", printError);
//               ElMessage({
//                 message: `订单 ${order.id} 打印失败`,
//                 type: "error",
//               });
//             }
//           }, index * 2000); // 每个订单间隔2秒打印
//         });

//         // 更新已处理订单列表
//         newlyPaidOrders.forEach((order) => {
//           processedPaidOrders.push(order.id);
//         });

//         // 限制存储的订单ID数量，只保留最近100个
//         if (processedPaidOrders.length > 100) {
//           processedPaidOrders.splice(0, processedPaidOrders.length - 100);
//         }

//         // 保存到localStorage
//         localStorage.setItem("newlyPaidOrders", JSON.stringify(processedPaidOrders));
//       }
//     })
//     .catch((error) => {
//       // 静默处理错误，避免影响用户正常使用
//       console.log("检查新支付订单时出错:", error);
//     });
// };

// 添加静默打印函数（全自动打印）
// const silentPrintReceipt = (order, copies = 2) => {
//   // 创建一个隐藏的iframe用于打印
//   const iframe = document.createElement('iframe');
//   iframe.style.position = 'absolute';
//   iframe.style.top = '-10000px';
//   iframe.style.left = '-10000px';
//   iframe.style.width = '0px';
//   iframe.style.height = '0px';
//   document.body.appendChild(iframe);

//   const doc = iframe.contentDocument || iframe.contentWindow.document;

//   // 生成小票HTML内容（使用你现有的样式）
//   let receiptHtml = '';
//   for (let i = 0; i < copies; i++) {
//     receiptHtml += `
//       <!-- 店铺信息 -->
//       <div class="text-center">
//         <img src="${logoImg}" class="logo" style="max-width: 50mm; display: block; margin: 3mm auto">
//       </div>

//       <!-- 订单标识 -->
//       <div class="text-center bold mt-5" style="font-weight: bold; text-align: center; margin-top: 5px">好吃的欧包</div>

//       <!-- 订单信息 -->
//       <div class="mt-5" style="margin-top: 5px">
//         <div>订单号：${order.id}</div>
//         <div>下单时间：${order.addOrderTime}</div>
//         <div class="note bold" style="color: #ff0000; font-weight: bold">整单备注：${order.message || "顾客需要餐具"}</div>
//       </div>
//       <div class="divider mt-5" style="border-top: 1px dashed #000; margin: 5px 0"></div>
//       <div class="mt-5" style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center">
//         <div class="bold" style="font-weight: bold">名称</div>
//         <div style="display: flex;">
//           <span style="width:50px">数量</span>
//           <span style="width:50px">规格</span>
//           <span style="width:50px">金额</span>
//         </div>
//       </div>

//       <!-- 分隔线 -->
//       <div class="divider" style="border-top: 1px dashed #000; margin: 5px 0"></div>

//       <!-- 商品信息 -->
//       <div class="mt-5" style="margin-top: 5px">
//         <div class="bold" style="font-weight: bold">${order.goodsName}</div>
//         <div style="display: flex; justify-content:right;">
//           <span style="width:50px">${order.goodsNumber} </span>
//           <span style="width:50px">${order.ordersSpecName || ""}</span>
//           <span style="width:50px">￥${order.orderPrice}</span>
//         </div>
//       </div>

//       <!-- 分隔线 -->
//       <div class="divider mt-5" style="border-top: 1px dashed #000; margin: 5px 0"></div>

//       <!-- 订单汇总 -->
//       <div class="mt-5" style="margin-top: 5px">
//         <div>商品数量：${order.goodsNumber}</div>
//         <div>顾客姓名：${order.consignee || ""}</div>
//         <div>联系电话：${order.mobile}</div>
//       </div>
//       <div class="divider mt-5" style="border-top: 1px dashed #000; margin: 5px 0"></div>
//       <div class="mt-5" style="margin-top: 5px">
//         <div>门店电话:1231313233</div>
//         <div>门店地址:哈哈哈哈</div>
//         <div>打印时间:${new Date().toLocaleString()}</div>
//       </div>
//       ${i < copies - 1 ? '<div style="page-break-after: always"></div>' : ""}
//     `;
//   }

//   // 写入HTML内容
//   doc.open();
//   doc.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <meta charset="UTF-8">
//       <style>
//         @media print {
//           @page { 
//             size: 76mm auto; 
//             margin: 0; 
//           }
//           body { 
//             width: 76mm;
//             margin: 0; 
//             padding: 0;
//             font-family: 'Courier New', monospace;
//             font-size: 13px;
//             line-height: 1.3;
//           }
//         }
//       </style>
//     </head>
//     <body>
//       ${receiptHtml}
//     </body>
//     </html>
//   `);
//   doc.close();

//   // 等待内容加载完成后打印
//   setTimeout(() => {
//     try {
//       // 触发打印
//       iframe.contentWindow.focus();
//       iframe.contentWindow.print();

//       // 延迟移除iframe
//       setTimeout(() => {
//         document.body.removeChild(iframe);
//       }, 1000);
//     } catch (error) {
//       console.error('打印出错:', error);
//       document.body.removeChild(iframe);
//     }
//   }, 500);
// };

// 组件挂载时触发
onMounted(() => {
  sift();

  // 初始化时获取楼栋信息
  fetchBuildingOptions();

  // 启动定时检查新支付订单（每15秒检查一次）
  // paidOrderCheckInterval = setInterval(() => {
  //   checkNewlyPaidOrders();
  // }, 15000);
});

onUnmounted(() => {
  if (paidOrderCheckInterval) {
    clearInterval(paidOrderCheckInterval);
  }
});

// 当前页码改变时触发
const handleCurrentChange = (val) => {
  page.pageNum = val;
  //console.log(val);
  sift();
};
const Ingredients = () => {
  if (localStorage.getItem("permissionsStatus") === "0") {
    const datas = {
      addOrderTimeBegin: addOrderTimeBegin.value,
      addOrderTimeEnd: addOrderTimeEnd.value,
      orderStatus: value.value,
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      wxUserId: "",
      id: input.value,
    };
    instance
      .post("/api/orders/export", datas, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "今日食材.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        ElMessage({
          message: "导出成功",
          type: "success",
        });
      })
      .catch((error) => {
        //console.error(error);
        ElMessage({
          message: "请重新登录",
          type: "error",
        });
      });
  } else {
    const datas = {
      addOrderTimeBegin: addOrderTimeBegin.value,
      addOrderTimeEnd: addOrderTimeEnd.value,
      orderStatus: value.value,
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      storeId: localStorage.getItem("sysStoreId"),
      wxUserId: "",
      id: input.value,
    };
    instance
      .post("/api/orders/export", datas, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "今日食材.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        ElMessage({
          message: "导出成功",
          type: "success",
        });
      })
      .catch((error) => {
        //console.error(error);
        ElMessage({
          message: "请重新登录",
          type: "error",
        });
      });
  }
};
const canBatchVerify = ref(false);

// 批量核销操作
const batchVerify = () => {
  ElMessageBox.confirm("您是否确认批量核销这些订单?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      loading.value = true;
      const batchShipments = multipleSelection.value.map((item) => {
        return {
          outTradeNo: item.id,
          itemDesc: item.goodsName,
          logisticsType: 4,
          receiverContact: item.mobile,
          openid: item.openId,
        };
      });

      const promises = batchShipments.map((shipment) => {
        return instance.post("/api/orders/orderDelivery", shipment);
      });

      Promise.all(promises)
        .then((responses) => {
          const successCount = responses.filter((response) => response.status === 200)
            .length;
          if (successCount === batchShipments.length) {
            ElMessage({
              type: "success",
              message: `批量核销成功`,
            });
          } else {
            ElMessage({
              type: "warning",
              message: `部分核销成功，成功数量: ${successCount}`,
            });
          }
          loading.value = false;
          sift();
        })
        .catch((error) => {
          //console.log(error);
          ElMessage({
            type: "error",
            message: `批量核销失败`,
          });
          loading.value = false;
        });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消批量核销",
      });
    });
};
// 导出订单数据
const exports = () => {
  if (value2.value) {
    addOrderTimeBegin.value = value2.value[0];
    addOrderTimeEnd.value = value2.value[1];
  }
  if (localStorage.getItem("permissionsStatus") === "0") {
    const datas = {
      addOrderTimeBegin: addOrderTimeBegin.value,
      addOrderTimeEnd: addOrderTimeEnd.value,
      orderStatus: value.value,
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      wxUserId: "",
      id: input.value,
    };
    instance
      .post("/api/orders/export", datas, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "订单流水.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        ElMessage({
          message: "导出成功",
          type: "success",
        });
      })
      .catch((error) => {
        //console.error(error);
        ElMessage({
          message: "请重新登录",
          type: "error",
        });
      });
  } else {
    const datas = {
      addOrderTimeBegin: addOrderTimeBegin.value,
      addOrderTimeEnd: addOrderTimeEnd.value,
      orderStatus: value.value,
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      storeId: localStorage.getItem("sysStoreId"),
      wxUserId: "",
      id: input.value,
    };
    instance
      .post("/api/orders/export", datas, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "订单流水.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        ElMessage({
          message: "导出成功",
          type: "success",
        });
      })
      .catch((error) => {
        //console.error(error);
        ElMessage({
          message: "请重新登录",
          type: "error",
        });
      });
  }
};

// 查看订单详情
const detail = (id) => {
  //console.log(id);
  showModals.value = true;
  instance
    .get(`/api/orders/details/` + id)
    .then((response) => {
      detaile.value = response.data.data;
      //console.log(response.data.data);
      detailes.value = toRaw(detaile.value);
      //console.log(detailes.value);
    })
    .catch((error) => {
      //console.log(error);
      ElMessage({
        showClose: true,
        message: "请登录",
        type: "error",
      });
    });
};

// 关闭详情弹窗
const toggleModals = () => {
  showModals.value = false;
};

// 订单状态选择默认值
const value = ref([
  {
    value: 1,
    label: "已支付",
  },
]);
// 订单状态选项
const options = [
  {
    value: 1,
    label: "已支付",
  },
  {
    value: 2,
    label: "待配送",
  },
  {
    value: 3,
    label: "待收货",
  },
  {
    value: 4,
    label: "已完成",
  },
  {
    value: 5,
    label: "已退款",
  },
  {
    value: 6,
    label: "申请退款",
  },
  {
    value: "",
    label: "全部订单",
  },
];

const state = ref([]);
const states = ref([]);

// 订单号输入框值
const input = ref("");

// 部分退款操作
const refund = (
  id,
  goodsName,
  mobile,
  orderStatus,
  wxUserId,
  addOrderTime,
  storeId,
  message,
  orderPrice,
  goodsId,
  goodsNumber,
  goodsUrl,
  shippingMethod,
  storeName,
  storeTxImg,
  ordersSystemType
) => {
  //console.log(id);
  ElMessageBox.prompt("是否确认退款", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
  })
    .then(({ value }) => {
      if (value === "") {
        ElMessage({
          type: "error",
          message: `退款失败,金额为空`,
        });
      } else {
        if (orderStatus !== 0 && orderStatus !== 4 && orderStatus !== 5) {
          if (value <= orderPrice) {
            // const orderPrices = parseInt(orderPrice * 100);
            const values = parseInt(value * 100);
            const refundable = {
              outTradeNo: id,
              // total: orderPrices,
              refund: values,
            };
            //console.log(refundable);
            instance
              .post(`/api/pay/payRefund`, refundable)
              .then((response) => {
                //console.log(response.data);
                //console.log('修改成功');
                ElMessage({
                  type: "success",
                  message: `退款成功，退款金额为${value}`,
                });
                sift();
              })
              .catch((error) => {
                //console.error(error);
              });
          } else {
            ElMessage({
              type: "error",
              message: `退款失败，金额大于或等于用户付款金额`,
            });
          }
        } else {
          if (orderStatus === 0) {
            ElMessage({
              type: "error",
              message: `退款失败，该用户未支付`,
            });
          }
          if (orderStatus === 4) {
            ElMessage({
              type: "error",
              message: `退款失败，订单已完成`,
            });
          }
          if (orderStatus === 5) {
            ElMessage({
              type: "error",
              message: `退款失败，订单已退款`,
            });
          }
        }
      }
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消退款",
      });
    });
};

// 全额退款操作
const refunds = (
  id,
  goodsName,
  mobile,
  openId,
  orderStatus,
  wxUserId,
  addOrderTime,
  storeId,
  message,
  orderPrice,
  goodsId,
  goodsNumber,
  goodsUrl,
  shippingMethod,
  storeName,
  storeTxImg,
  ordersSystemType
) => {
  //console.log(id);
  //console.log(orderPrice);
  //console.log(orderStatus);
  //console.log(ordersSystemType);
  ElMessageBox.confirm("您是否全额退款?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      if (orderStatus === 6) {
        // const orderPrices = parseInt(orderPrice * 100);
        const values = parseInt(orderPrice * 100);
        const refundable = {
          outTradeNo: id,
          // total: orderPrices,
          refund: values,
        };
        //console.log(refundable);
        instance
          .post(`/api/pay/payRefund`, refundable)
          .then((response) => {
            ElMessage({
              type: "success",
              message: "退款成功",
            });
            sift();
          })
          .catch((error) => {
            //console.log(error);
          });
      } else {
        if (orderStatus === 0) {
          ElMessage({
            type: "error",
            message: `退款失败，该用户未支付`,
          });
        }
        if (orderStatus === 4) {
          ElMessage({
            type: "error",
            message: `退款失败，订单已完成`,
          });
        }
        if (orderStatus === 5) {
          ElMessage({
            type: "error",
            message: `退款失败，订单已退款`,
          });
        }
      }
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消退款",
      });
    });
};

// 日期范围开始时间
const addOrderTimeBegin = ref("");
// 日期范围结束时间
const addOrderTimeEnd = ref("");
// 筛选订单数据
const sift = () => {
  loading.value = true;
  addOrderTimeBegin.value = "";
  addOrderTimeEnd.value = "";


  if (value2.value) {
    console.log(value2.value);

    // 格式化日期字符串为 "YYYY-MM-DD HH:MM:SS" 格式
    const formatToSeconds = (dateInput) => {
      let date;
      // 尝试多种方式转换为Date对象
      if (typeof dateInput === 'string') {
        // 处理可能的时区问题，去除括号内的时区描述
        const cleaned = dateInput.replace(/\s\([^)]+\)/, '');
        date = new Date(cleaned);
      } else {
        date = new Date(dateInput);
      }

      // 检查日期是否有效
      if (isNaN(date.getTime())) {
        console.error('无效的日期格式:', dateInput);
        return ''; // 或返回默认值
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    addOrderTimeBegin.value = formatToSeconds(value2.value[0]);
    addOrderTimeEnd.value = formatToSeconds(value2.value[1]);
  }
  // 存储之前获取的订单ID
  const previousOrderIds = orderser.value ? orderser.value.map((o) => o.id) : [];

  // 构造基础查询参数（不包含楼栋筛选）
  let datas = {
    addOrderTimeBegin: addOrderTimeBegin.value,
    addOrderTimeEnd: addOrderTimeEnd.value,
    orderStatus: value.value,
    pageNum: page.pageNum,
    pageSize: page.pageSize,
    wxUserId: "",
    id: input.value,
    address: selectedBuilding.value
  };
  console.log(datas)
  // 根据权限添加 storeId
  if (localStorage.getItem("permissionsStatus") !== "0") {
    datas.storeId = localStorage.getItem("sysStoreId");
  }

  console.log(addOrderTimeEnd.value)
  instance
    .post("/api/orders/list", datas)
    .then((res) => {

      total.value = res.data.data.total;
      orderse.value = res.data.data.dataList;
      orderser.value = toRaw(orderse.value);
      loading.value = false;

      // 检查是否有新订单需要自动打印
      checkAndPrintNewOrders(orderser.value, previousOrderIds);
    })
    .catch((error) => {
      console.log(error);
      ElMessage({
        message: "请重新登录",
        type: "error",
      });
      loading.value = false;
    });
};

// 添加检查并打印新订单的函数
const checkAndPrintNewOrders = (currentOrders, previousOrderIds) => {
  // 获取之前已处理的订单ID
  const processedOrders = JSON.parse(localStorage.getItem("processedOrders") || "[]");

  // 查找新创建的待配送订单（之前不存在且未处理过的订单）
  const newOrders = currentOrders.filter(
    (order) =>
      order.orderStatus === 2 && // 待配送状态
      !previousOrderIds.includes(order.id) && // 之前不存在
      !processedOrders.includes(order.id) // 未处理过
  );

  // 对新订单自动打印小票 (important)
  // newOrders.forEach((order) => {
  //   setTimeout(() => {
  //     printReceiptCopies(order, 2);
  //   }, 1000); // 延迟1秒打印，确保数据完整

  //   // 标记为已处理
  //   processedOrders.push(order.id);
  // });

  // 保存已处理订单列表（只保留最近100个，避免localStorage过大）
  if (processedOrders.length > 100) {
    processedOrders.splice(0, processedOrders.length - 100);
  }
  localStorage.setItem("processedOrders", JSON.stringify(processedOrders));
};

// 佣金
const commissions = ref("");
// 金额
const money = ref("");

// 合销操作
const opes = (id, orderStatus, goodsId, inviteId) => {
  //console.log(orderStatus);
  //console.log(inviteId);
  //console.log(goodsId);
  ElMessageBox.prompt("订单号", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    inputPattern: /^[0-9]+$/,
    inputErrorMessage: "订单号不正确",
  })
    .then(({ value }) => {
      if (orderStatus !== 0) {
        if (value === id) {
          instance
            .put(`/api/orders/status4/${id}`)
            .then((response) => {
              //console.log(response.data);
              //console.log('修改成功');
              ElMessage({
                message: "订单已完成",
                type: "success",
              });
              sift();
            })
            .catch((error) => {
              //console.error(error);
            });
          if (inviteId) {
            instance.get(`/api/tproduct/${goodsId}`).then((response) => {
              //console.log(response.data.data);
              commissions.value = response.data.data.commission;
              instance
                .get(`/api/distribution/selectDistributionAmountByWxUserId/${inviteId}`)
                .then((response) => {
                  //console.log(response.data.data.distributionAmount);
                  //console.log(commissions.value);
                  money.value = commissions.value + response.data.data.distributionAmount;
                  //console.log(money.value);
                  instance
                    .put(`api/distribution?money=${money.value}&wxUserld=${inviteId}`)
                    .then((response) => {
                      //console.log(response);
                      ElMessage({
                        message: "订单已完成",
                        type: "success",
                      });
                      sift();
                    })
                    .catch((error) => {
                      //console.log(error);
                    });
                });
            });
          }
        } else {
          ElMessage({
            type: "error",
            message: "订单号与ID不匹配",
          });
        }
      } else {
        ElMessage({
          type: "error",
          message: "订单状态为未支付，不能修改",
        });
      }
      //console.log(value);
      //console.log(id);
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消输入",
      });
    });
};

// 发货操作
const shipments = (
  id,
  goodsName,
  mobile,
  openId,
  orderStatus,
  wxUserId,
  addOrderTime,
  storeId,
  message,
  orderPrice,
  goodsId,
  goodsNumber,
  goodsUrl,
  shippingMethod,
  storeName,
  storeTxImg
) => {
  //console.log(id, goodsName, mobile, openId, orderStatus);
  ElMessageBox.confirm("您是否确认配送?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      loading.value = true;
      if (orderStatus === 2 || orderStatus === 1) {
        const shipment = {
          outTradeNo: id,
          // trackingNo: value,
          itemDesc: goodsName,
          logisticsType: 4,
          receiverContact: mobile,
          openid: openId,
        };
        instance
          .post("/api/orders/orderDelivery", shipment)
          .then((response) => {
            ElMessage({
              type: "success",
              message: `发货成功`,
            });
            loading.value = false;

            // 发货成功后自动打印两张小票
            // 构建订单对象用于打印
            const order = {
              id,
              goodsName,
              mobile,
              openId,
              orderStatus,
              wxUserId,
              addOrderTime,
              storeId,
              message,
              orderPrice,
              goodsId,
              goodsNumber,
              goodsUrl,
              shippingMethod,
              storeName,
              storeTxImg,
            };

            // 打印两张小票
            printReceiptCopies(order, 2);

            sift();
          })
          .catch((error) => {
            //console.log(error);
            ElMessage({
              type: "error",
              message: `发货失败`,
            });
            loading.value = false;
          });
      } else {
        ElMessage({
          type: "error",
          message: `该商品未处于待发货状态`,
        });
      }
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消发货",
      });
    });
};

// 打印指定数量的小票副本
const printReceiptCopies = (order, copies = 2) => {
  const receiptLogo = logoImg;
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "-10000px";
  iframe.style.left = "-10000px";
  iframe.style.width = "200mm";
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument;

  // 生成多个副本的HTML内容
  let receiptHtml = "";
  for (let i = 0; i < copies; i++) {
    receiptHtml += `
      <!-- 店铺信息 -->
      <div class="text-center">
        <img src="${receiptLogo}" class="logo">
      </div>
      
      <!-- 订单标识 -->
      <div class="text-center bold mt-5">好吃的欧包</div>
      
      <!-- 订单信息 -->
      <div class="mt-5">
        <div>订单号：${order.id}</div>
        <div>下单时间：${order.addOrderTime}</div>
        <div class="note bold">整单备注：${order.message || "顾客需要餐具"}</div>
      </div>
      <div class="divider mt-5"></div>
      <div class="mt-5" style="display: flex; justify-content: space-between; align-items: center">
        <div class="bold">名称</div>
        <div style="display: flex;">
          <span style="width:50px">数量</span>
          <span style="width:50px">规格</span>
          <span style="width:50px">金额</span>
        </div>
      </div>
      
      <!-- 分隔线 -->
      <div class="divider"></div>
      
      <!-- 商品信息 -->
      <div class="mt-5">
        <div class="bold">${order.goodsName}</div>
        <div style="display: flex; justify-content:right;">
          <span style="width:50px">${order.goodsNumber} </span>
          <span style="width:50px">${order.ordersSpecName || ""}</span>
          <span style="width:50px">￥${order.orderPrice}</span>
        </div>
      </div>
      
      <!-- 分隔线 -->
      <div class="divider mt-5"></div>
      
      <!-- 订单汇总 -->
      <div class="mt-5">
        <div>商品数量：${order.goodsNumber}</div>
        <div>顾客姓名：${order.consignee || ""}</div>
        <div>联系电话：${order.mobile}</div>
      </div>
      <div class="divider mt-5"></div>
      <div class="mt-5">
        <div>门店电话:1231313233</div>
        <div>门店地址:哈哈哈哈</div>
        <div>打印时间:${new Date().toLocaleString()}</div>
      </div>
      ${i < copies - 1 ? '<div style="page-break-after: always"></div>' : ""}
    `;
  }

  doc.write(`
    <!DOCTYPE html>
    <html style="font-family: 'Courier New', monospace;">
    <head>
      <meta charset="UTF-8">
      <style>
        @media print {
          body { 
            width: 76mm;
            margin: 0 auto; 
            padding: 0;
            font-size: 13px;
            line-height: 1.3;
          }
          .text-center { text-align: center }
          .logo { max-width: 50mm; display: block; margin: 3mm auto }
          .divider { border-top: 1px dashed #000; margin: 5px 0 }
          .bold { font-weight: bold }
          .mt-5 { margin-top: 5px }
          .mb-5 { margin-bottom: 5px }
          .note { color: #ff0000 }
        }
      </style>
    </head>
    <body>
      ${receiptHtml}
    </body>
    </html>
  `);

  doc.close();
  setTimeout(() => {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  }, 500);
};

// 提取地址中的特定部分（从 startIndex 到 endIndex 之间的部分）
function getAddressPart(address, startIndex = 0, endIndex = 1) {
  if (!address) return "—";
  const parts = address.split("-");
  if (parts.length <= startIndex) return "—";

  // 如果没有指定 endIndex，或者超出范围，则取到最后一部分
  const end = endIndex < parts.length ? endIndex : parts.length;
  return parts.slice(startIndex, end).join("-");
}

// 表格选择项改变时触发
// const handleSelectionChange = (val) => {
//     multipleSelection.value = val;
//     //console.log(multipleSelection.value);
// };
const printSelectedAsPDF = async () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning("请先选择要打印的内容");
    return;
  }

  const checkLogo = () => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = logoImg;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };
  const now = new Date();
  const printTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(
    2,
    "0"
  )}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(
    2,
    "0"
  )}`;
  const hasLogo = await checkLogo();
  if (!hasLogo) {
    ElMessage.error("Logo 资源加载异常，无法打印");
    return;
  }

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

  const htmlContent = `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="UTF-8">
      <style>
        @page { margin: 0; size: auto; }
        html, body { margin: 0; padding: 0; font-family: 'Microsoft YaHei', serif; width: 100%; height: 100%; }
        .print-item { page-break-after: always; min-height: 100%; display: flex; flex-direction: column; box-sizing: border-box; }
        
        .hospital-header { display: flex; align-items: center; padding: 8px; justify-content: flex-start; }
        .logo-container { width: auto; }
        .hospital-logo { width: 100%; height: 60px; object-fit: contain; }
        
        .info-section { padding: 4px 16px; }
        .info-row { display: flex; padding: 2px 0; }
        .info-label { font-weight: 900; min-width: 80px; }
        
        .content-table { display: table; width: 100%; border-collapse: collapse; margin: 4px 0; }
        .content-row { display: table-row; }
        .content-cell { padding: 6px 16px; vertical-align: top; border: none; }
        
        .nutrition-group { 
          display: grid; 
          grid-template-columns: repeat(4, minmax(0, 1fr)); /* 优化列宽 */
          column-gap: 2px; /* 只控制列间距（左右间距） */
          row-gap: 8px;     /* 保持行间距不变（上下间距） */
          margin-top: 8px;
        }
        .nutrition-item { 
          display: flex; 
          flex-direction: column;
          padding: 0 1px;
        }
        .nutrition-label { 
          font-weight: bold; 
          margin-bottom: 1px; /* 减小标签与内容间距 */
          font-size: 14px; /* 减小字体 */
          white-space: nowrap; /* 防止标签换行 */
          text-align: center;
        }
        .nutrition-value { 
          min-height: 18px; /* 减小内容高度 */
          font-size: 14px; /* 减小字体 */
          text-align: center;
        }
        
        .print-time { padding: 4px 16px; font-size: 12px; color: #666; text-align: left; }
        .notice { padding: 4px 16px; font-size: 12px; color: #666; }
        .content-cells {
       font-size: 28px;
        }
       
        /* 添加楼层文本单行显示限制 */
        .floor-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          max-width: 300px; /* 可根据需要调整 */
        }
      </style>
    </head>
    <body>
      ${multipleSelection.value
      .map(
        (row) => `
        <div class="print-item">

          <div class="info-section">
            <div class="info-row">
              <span class="info-label">病区：</span>
              <span><strong>${getAddressPart(row.address, 1, 2)}</strong></span>
            </div>
            <div class="info-row">
              <span class="info-label">楼层：</span>
              <span><strong><span class="floor-text">${getAddressPart(row.address, 2, 4)}</span></strong></span>
            </div>
            <div class="info-row">
              <span class="info-label">姓名：</span>
              <span><strong>${row.consignee || "—"}</strong></span>
            </div>
          </div>

          <div class="content-table">
            <div class="content-row">
              <span class="content-cell info-label">套餐：</span>
              <span class="content-cell"><strong>${row.goodsName || "—"}-${row.ordersSpecName
          }</strong>-<span class="content-cells"> ${row.specMultipleValue}<span></span>
            </div>
            <div class="content-row">
              <div class="content-cell">
                <div class="nutrition-group">
                  <div class="nutrition-item">
                    <div class="nutrition-label">能量</div>
                    <div class="nutrition-value">${row.energy || "—"}</div>
                  </div>
                  <div class="nutrition-item">
                    <div class="nutrition-label">脂肪</div>
                    <div class="nutrition-value">${row.fat || "—"}</div>
                  </div>
                  <div class="nutrition-item">
                    <div class="nutrition-label">蛋白质</div>
                    <div class="nutrition-value">${row.protein || "—"}</div>
                  </div>
                  <div class="nutrition-item">
                    <div class="nutrition-label">碳水化合物</div>
                    <div class="nutrition-value">${row.carbs || "—"}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="print-time">打印时间：${printTime}</div>
          <div class="notice">基于食材的食物成分表折算，基于标准制作折算</div>
      `
      )
      .join("")}
    </body>
  </html>
  `;

  iframeDoc.open();
  iframeDoc.write(htmlContent);
  iframeDoc.close();

  iframe.onload = () => {
    const contentWindow = iframe.contentWindow;
    contentWindow.print();
    setTimeout(() => document.body.removeChild(iframe), 100);
  };
};
// 核心打印函数：严格匹配小票格式
const printSelectedReceipts = () => {
  if (!multipleSelection.value.length) {
    ElMessage.warning("请先勾选订单");
    return;
  }
  const receiptLogo = logoImgs;
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "-1000px";
  iframe.style.left = "-1000px";
  iframe.style.width = "200mm";
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument;

  doc.write(`
    <!DOCTYPE html>
    <html style="font-family: 'Courier New', monospace;">
    <head>
      <meta charset="UTF-8">
      <style>
        @media print {
          body { 
            width: 76mm;
            margin: 0 auto; 
            padding: 0;
            font-size: 13px;
            line-height: 1.3;
          }
          .text-center { text-align: center }
          /* 等比缩小logo样式 */
          .logo-container {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .logo { 
            max-width: 65mm;  /* 最大宽度限制 */
            max-height: 35mm; /* 最大高度限制 */
            width: auto;      /* 宽度自动适应 */
            height: auto;     /* 高度自动适应 */
            object-fit: contain; /* 保持比例，不裁剪 */
          }
          .divider { border-top: 1px dashed #000; margin: 5px 0 }
          .bold { font-weight: bold }
          .mt-5 { margin-top: 5px }
          .mb-5 { margin-bottom: 5px }
          .note { color: #ff0000 }
        }
      </style>
    </head>
    <body>
      ${multipleSelection.value
      .map(
        (order) => `
        <!-- 店铺信息（带等比缩小的logo） -->
        <div class="text-center logo-container">
          <img src="${receiptLogo}" class="logo" alt="店铺logo">
        </div>
        
        <!-- 订单标识 -->
        <div class="text-center bold mt-5">好吃的欧包</div>
        
        <!-- 订单信息 -->
        <div class="mt-5">
          <div>订单号：${order.id}</div>
          <div>下单时间：${order.addOrderTime}</div>
          <div class="note bold">整单备注：${order.message || "顾客需要餐具"}</div>
        </div>
        <div class="divider mt-5"></div>
       <div class="mt-5" style="display: flex; justify-content: space-between; align-items: center">
  <div class="bold">名称</div>
  <div style="display: flex;">
    <span style="width:50px">数量</span>
    <span style="width:50px">规格</span>
    <span style="width:50px">金额</span>
  </div>
</div>
        
        <!-- 分隔线 -->
        <div class="divider"></div>
        
        <!-- 商品信息 -->
        <div class="mt-5">
          <div class="bold">${order.goodsName}</div>
          <div style="display: flex; justify-content:right;">
            <span style="width:50px">${order.goodsNumber} </span>
            <span style="width:50px">${order.ordersSpecName}</span>
            <span style="width:50px">￥${order.orderPrice}</span>
          </div>
        </div>
        
        <!-- 分隔线 -->
        <div class="divider mt-5"></div>
        
        <!-- 订单汇总 -->
        <div class="mt-5">
          <div>商品数量：${order.goodsNumber}</div>
          <div>顾客姓名：${order.consignee}</div>
          <div>联系电话：${order.mobile}</div>
        </div>
        <div class="divider mt-5"></div>
         <div class="mt-5">
          <div>门店电话:${order.serviceTel}</div>
          <div>门店地址:${order.storeAddress}</div>
          <div>打印时间:${new Date().toLocaleString()}</div>
        </div>
      `
      )
      .join('<div style="page-break-after: always"></div>')}
    </body>
    </html>
  `);

  doc.close();
  setTimeout(() => {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  }, 500);
};

const hasSelectedOrders = ref(false);
// 监听选中订单变化，控制按钮状态
watch(
  () => multipleSelection.value.length,
  (length) => {
    hasSelectedOrders.value = length > 0;
  }
);
const showExportDialog = ref(false);
const exportForm = reactive({
  date: "", // 单个日期
  dataType: "kitchen", // 默认导出厨房数据
});
onMounted(() => {
  // 其他原有逻辑
  setDefaultDate();
});
const setDefaultDate = () => {
  const today = new Date();
  exportForm.date = today.toISOString().split("T")[0]; // 格式化为 YYYY-MM-DD
};
const handleClose = () => {
  showExportDialog.value = false;
  // 重置表单
  setDefaultDate();
  exportForm.dataType = "kitchen";
};
const confirmExport = () => {
  if (!exportForm.date) {
    ElMessage.warning("请选择日期");
    return;
  }

  // 构建请求参数（仅包含单个日期）

  // 根据选择调用不同接口
  if (exportForm.dataType === "kitchen") {
    exportKitchenData(exportForm.date);
  } else {
    exportStatementData(exportForm.date);
  }
};

// 导出厨房数据
const exportKitchenData = (params) => {
  instance
    .post(`/api/orders/exportToKitchen?printDate=${params}`, {}, { responseType: "blob" })
    .then((response) => {
      // 从响应头中获取 Content-Disposition 信息
      const contentDisposition = response.headers["content-disposition"];
      // 从响应头中获取 Content-Type 信息
      const contentType = response.headers["content-type"];

      // 解析文件名
      let fileName = "厨房.xlsx"; // 默认文件名
      if (contentDisposition) {
        // 正则表达式提取文件名
        const match = contentDisposition.match(/filename=([^;]+)/);
        if (match && match[1]) {
          // 解码文件名（处理可能的编码，如 UTF-8 编码）
          fileName = decodeURIComponent(match[1]);
        }
      }

      // 创建 Blob 对象
      const blob = new Blob([response.data], { type: contentType });

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // 使用解析后的文件名
      document.body.appendChild(link);
      link.click();

      // 释放 URL 对象
      window.URL.revokeObjectURL(url);

      // 提示导出成功
      ElMessage({
        message: "导出成功",
        type: "success",
      });
    })
    .catch((error) => {
      handleExportError(error);
    });
};

// 导出对账单数据
const exportStatementData = (params) => {
  instance
    .post(`/api/orders/exportToSign?printDate=${params}`, {}, { responseType: "blob" })
    .then((response) => {
      // 从响应头中获取 Content-Disposition 信息
      const contentDisposition = response.headers["content-disposition"];
      // 从响应头中获取 Content-Type 信息
      const contentType = response.headers["content-type"];

      // 解析文件名
      let fileName = "对账单.xlsx"; // 默认文件名
      if (contentDisposition) {
        // 正则表达式提取文件名
        const match = contentDisposition.match(/filename=([^;]+)/);
        if (match && match[1]) {
          // 解码文件名（处理可能的编码，如 UTF-8 编码）
          fileName = decodeURIComponent(match[1]);
        }
      }

      // 创建 Blob 对象
      const blob = new Blob([response.data], { type: contentType });

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // 使用解析后的文件名
      document.body.appendChild(link);
      link.click();

      // 释放 URL 对象
      window.URL.revokeObjectURL(url);

      // 提示导出成功
      ElMessage({
        message: "导出成功",
        type: "success",
      });
    })
    .catch((error) => {
      handleExportError(error);
    });
};
</script>

<style>
.container {
  position: fixed;
  top: 0;
  left: 15vw;
}

.main {
  position: fixed;
  top: 10vh;
  left: 15vw;
}

.allorders {
  display: inline-block;
  position: fixed;
  left: 11vw;
  top: 15vh;
  width: 85vw;
  height: 100vh;
  font-size: 12px !important;
}

.allorders .el-table .el-table__cell {
  text-overflow: ellipsis;
}

.allorders .OrderNumber {
  width: 20vw;
}

.allorders .el-table tr.el-table__row {
  height: 5rem !important;
  /* background-color: aqua; */
}

.allorders .el-table__inner-wrapper {
  width: 85vw !important;
  /* height: 100vh !important; */
}

/* .allorders .el-table_1_column_1 .cell {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 1 !important;
    -webkit-box-orient: vertical !important;
    font-size: 12px !important;
} */

.allorders .el-table__header-wrapper {
  height: 8vh !important;
  font-size: 12px !important;
}

.allorders .el-table tr.el-table__row {
  height: 2vh !important;
}

.allorders .cell .el-button {
  font-size: 12px !important;
  height: 2vh !important;
}

.allorders .el-input__inner {
  display: inline-block !important;
  font-size: 12px !important;
  left: 0 !important;
}

.allorders .el-pagination {
  --el-pagination-item-gap: 15px;
  font-size: 12px !important;
  /* margin-left: 23% !important;
     */
  justify-content: center;
  margin-top: 3vh !important;
}

.allorders .el-table .el-table__cell {
  padding: 1 !important;
}

.el-pager li {
  font-size: 1vw !important;
}

/* .allorders .el-pagination .el-select .el-input {
    width: 3vw !important;
} */

/* .allorders .OrderNumber {
    width: 10vw !important;
    position: relative !important;
    top: -4vh !important;
    left: 1vw !important;
} */
.allorders .zhuang {
  display: flex;
  align-items: center;
  gap: 10px;
}

.zhuang1 {
  margin: 5px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;  
}

/* .allorders .zhuang {
    margin-top: -4vh;
} */

/* .zhuang .el-select {
    position: fixed;
    top: 11vh;
    left: 23vw;
    width: 10vw;
} */

.demo-pagination-block {
  position: fixed;
  top: 90vh;
  width: 85vw;
  /* left: 25%; */
}

.allorders .ding {
  width: 200px !important;
}

.allorders .el-table .cell {
  width: 200px;
}

body .el-table tr td {
  display: table-cell !important;
}

.el-table-fixed-column--left:hover {
  cursor: pointer;
}

.allorders .el-table__row .el-table__cell {
  width: 200px !important;
}

#details {
  /* display: flex; */
  margin-left: 0;
  /* margin-top: -1vh; */
}

.allorders .el-button {
  margin-left: 0 !important;
}

.allorders .cao {
  padding-left: 1vw;
}

.list {
  width: 100vw;
  height: 70vh;
}

.addproductse {
  position: fixed;
  top: 10vh;
  right: 15vw;
}

.list .el-table--border .el-table__inner-wrapper::after {
  z-index: 2;
}

.list .commentmodeae {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.list .modals-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.list .close {
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.list .edadmin {
  display: block;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
}

.popups-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.popups-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 80%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.popups-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.popups-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.popups-close {
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.popups-close:hover {
  color: #333;
}

.popups-body {
  padding: 24px;
}

.popups-footer {
  padding: 16px 24px;
  border-top: 1px solid #eee;
  text-align: right;
}

.price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

.el-form-item {
  margin-bottom: 18px;
}

:deep(.el-image) {
  border-radius: 4px;
}
.part{
  margin-left: 0 !important;
}

@media (max-width: 768px) {
  .popups-container {
    width: 95%;
    margin: 10px;
  }

  .el-row {
    flex-direction: column;
  }

  .el-col {
    width: 100%;
  }
}
</style>
